// import {bus} from '../components'
// import moment from "moment";
import Log from "@/module/trash/log.vue";
export default {
  methods: {
    getHandleType(parentId, childId, onlyValue) {
      // onlyValue==1只返回父，onlyValue==2只返回子，onlyValue为false，两个都返回
      let parentTitle, childTitle;

      switch (parentId) {
        case 1:
          parentTitle = "垃圾治理类";
          switch (childId) {
            case 1:
              childTitle = "垃圾乱堆乱倒";
              break;
            case 2:
              childTitle = "垃圾箱满无人清理";
              break;
            case 3:
              childTitle = "垃圾箱缺失";
              break;
            case 4:
              childTitle = "垃圾箱损坏";
              break;
            case 5:
              childTitle = "垃圾露天焚烧";
              break;
            case 6:
              childTitle = "其他";
              break;
            case 7:
              childTitle = "公共区域卫生";
              break;
            default:
              childTitle = "";
          }
          break;
        case 2:
          parentTitle = "公厕治理类";
          switch (childId) {
            case 1:
              childTitle = "卫生脏乱差";
              break;
            case 2:
              childTitle = "蹲位损坏";
              break;
            case 3:
              childTitle = "洗手池损坏";
              break;
            case 4:
              childTitle = "粪水溢满";
              break;
            case 5:
              childTitle = "照明设施损坏";
              break;
            case 6:
              childTitle = "门窗损坏";
              break;
            case 7:
              childTitle = "其他";
              break;
            default:
              childTitle = "";
          }
          break;
        case 3:
          parentTitle = "户厕治理类";
          switch (childId) {
            case 1:
              childTitle = "蹲位损坏";
              break;
            case 2:
              childTitle = "粪水溢满";
              break;
            case 3:
              childTitle = "照明设施损坏";
              break;
            case 4:
              childTitle = "门窗损坏";
              break;
            case 5:
              childTitle = "其他";
              break;
            default:
              childTitle = "";
          }
          break;
        case 4:
          parentTitle = "其他";
          switch (childId) {
            case 1:
              childTitle = "其他";
              break;
            default:
              childTitle = "";
          }
          break;
        default:
          parentTitle = "";
          childTitle = "";
      }
      if (onlyValue == 1) {
        return parentTitle;
      } else if (onlyValue == 2) {
        return childTitle;
      } else {
        let questionType = parentTitle + "" + childTitle;
        return questionType;
      }
    },
    deptList(value, type) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "党政办公室" },
        { id: 2, name: "经济发展办公室" },
        { id: 3, name: "社会事务办公室" },
        { id: 4, name: "社会管理综合治理办公室" },
        { id: 5, name: "公共卫生人口和计划生育办公室" },
        { id: 6, name: "农业服务中心" },
        { id: 7, name: "人力资源和社会保障服务中心" },
        { id: 8, name: "科技宣教文化信息服务中心" },
        { id: 9, name: "乡村建设服务中心" },
        { id: 10, name: "人口和计划生育技术服务站" },
        { id: 11, name: "林业站" },
        { id: 12, name: "财政所" },
        { id: 13, name: "安全生产监督管理站" },
        { id: 14, name: "乡村振兴工作站" },
        { id: 15, name: "其他" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    opSourceTypes(value, type) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "小程序端" },
        { id: 2, name: "app端" },
        { id: 3, name: "用户后台" },
        { id: 4, name: "运营后台" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    posList(value, type) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "党委书记" },
        { id: 2, name: "党委副书记" },
        { id: 3, name: "乡（镇）长" },
        { id: 4, name: "副乡（镇）长" },
        { id: 5, name: "人大主席" },
        { id: 6, name: "纪委书记" },
        { id: 7, name: "纪委委员" },
        { id: 8, name: "组织委员" },
        { id: 9, name: "宣传委员" },
        { id: 10, name: "统战委员" },
        { id: 11, name: "人武部部长" },
        { id: 12, name: "政法委员" },
        { id: 13, name: "党委委员" },
        { id: 14, name: "站长" },
        { id: 15, name: "办公室主任" },
        { id: 16, name: "工作人员" },
        { id: 17, name: "其他" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    positionLists(value, type) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "党支部书记" },
        { id: 2, name: "党支部副书记" },
        { id: 3, name: "党支部委员" },
        { id: 4, name: "党支书助理" },
        { id: 5, name: "村委会主任" },
        { id: 6, name: "村委会副主任" },
        { id: 7, name: "村委会委员" },
        { id: 8, name: "村委会主任助理" },
        { id: 9, name: "驻村书记" },
        { id: 10, name: "驻村干部" },
        { id: 11, name: "村指挥长" },
        { id: 12, name: "其他" },
        { id: 13, name: "支委委员" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    sourceObj(type, value) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "禾力拍积分发放" },
        { id: 2, name: "惠黔村兑换" },
        { id: 3, name: "村庄清洁行动" },
        { id: 4, name: "订单取消" },
        { id: 5, name: "徒步路线发放" },
        { id: 6, name: "其他" },
        { id: 7, name: "手动发放积分" },
        { id: 8, name: "大喇叭积分发放" },
        { id: 9, name: "连心桥积分发放" },
        { id: 10, name: "村务扣除" },
        { id: 11, name: "最美庭院积分发放" },
        { id: 12, name: "线下核销" },
        { id: 13, name: "AI视频生成" },
        { id: 14, name: "AI视频回退" },
        { id: 100, name: "充值" },
        { id: 101, name: "扣除" },
        { id: 102, name: "切换为正常账户" },
        { id: 103, name: "结算" },
        { id: 104, name: "转账" },
        { id: 105, name: "徒步贵州打卡奖励" },
        { id: 106, name: "徒步贵州活动问答奖励" },
        { id: 107, name: "徒步贵州摇一摇奖励" },
        { id: 108, name: "徒步贵州宝藏卡奖励" },
        { id: 109, name: "徒步贵州补卡奖励" },
        { id: 110, name: "亲子赛完赛奖励" },
        { id: 111, name: "亲子赛重赛扣除" },
        { id: 112, name: "亲子积分活动" },
        { id: 113, name: "徒步贵州任务奖励" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    walkSourceObj(type, value) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "禾力拍积分发放" },
        { id: 2, name: "惠黔村兑换" },
        { id: 3, name: "村庄清洁行动" },
        { id: 4, name: "订单取消" },
        { id: 5, name: "徒步路线发放" },
        { id: 6, name: "其他" },
        { id: 7, name: "手动发放积分" },
        { id: 8, name: "大喇叭积分发放" },
        { id: 9, name: "连心桥积分发放" },
        { id: 10, name: "村务扣除" },
        { id: 11, name: "最美庭院积分发放" },
        { id: 12, name: "线下核销" },
        { id: 13, name: "AI视频生成" },
        { id: 14, name: "AI视频回退" },
        { id: 100, name: "充值" },
        { id: 101, name: "扣减" },
        { id: 102, name: "切换为正常账户" },
        { id: 103, name: "结算" },
        { id: 104, name: "转账" },
        { id: 105, name: "徒步贵州打卡奖励" },
        { id: 106, name: "徒步贵州活动问答奖励" },
        { id: 107, name: "徒步贵州摇一摇奖励" },
        { id: 108, name: "徒步贵州宝藏卡奖励" },
        { id: 109, name: "徒步贵州补卡奖励" },
        { id: 110, name: "亲子赛完赛奖励" },
        { id: 111, name: "亲子赛重赛扣除" },
        { id: 112, name: "亲子积分活动" },
        { id: 113, name: "徒步贵州任务奖励" },
      ];
      if (value && type == "name") {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },

    integralsourceObj(type, value, other) {
      value = parseInt(value);
      let arr = [
        { id: 1, name: "禾力拍反馈问题" },
        { id: 2, name: "积分商城" },
        { id: 3, name: "村庄清洁行动" },
        { id: 4, name: "订单无效退回" },
        { id: 5, name: "徒步贵州" },
        { id: 6, name: "其他" },
        { id: 7, name: "村委奖励" },
        { id: 8, name: "查看大喇叭通知" },
        { id: 9, name: "连心桥反馈问题" },
        { id: 10, name: "村委扣除" },
        { id: 11, name: "最美庭院行动" },
        { id: 12, name: "乡镇奖励" },
        { id: 13, name: "AI视频生成" },
        { id: 14, name: "AI视频回退" },
        { id: 100, name: "充值" },
        { id: 101, name: "扣除" },
        { id: 102, name: "切换为正常账户" },
        { id: 103, name: "结算" },
        { id: 104, name: "转账" },
        { id: 105, name: "徒步贵州打卡奖励" },
        { id: 106, name: "徒步贵州活动问答奖励" },
        { id: 107, name: "徒步贵州摇一摇奖励" },
        { id: 108, name: "徒步贵州宝藏卡奖励" },
        { id: 109, name: "徒步贵州补卡奖励" },
        { id: 110, name: "亲子赛完赛奖励" },
        { id: 111, name: "亲子赛重赛扣除" },
        { id: 112, name: "亲子积分活动" },
        { id: 113, name: "徒步贵州任务奖励" },
      ];
      if (value && type == "name") {
        if (value == 1) {
          if (other == 2) {
            return "禾力拍处理问题";
          } else if (other == 1 || !other) {
            return "禾力拍反馈问题";
          } else {
            let index = arr.findIndex((item) => item.id == value);
            return index != -1 ? arr[index].name : "-";
          }
        } else {
          let index = arr.findIndex((item) => item.id == value);
          return index != -1 ? arr[index].name : "-";
        }
      } else if (type == "arr") {
        return arr;
      } else {
        return "";
      }
    },
    categoryList(type, value) {
      value = parseInt(value);
      let arr = [
        { id: 0, name: "全部" },
        { id: 1, name: "生活家居" },
        { id: 2, name: "粮油调味" },
        { id: 3, name: "虚拟权益" },
        { id: 4, name: "饮品专区" },
        { id: 5, name: "民俗文化" },
        { id: 6, name: "仅记账商品" },
        { id: 7, name: "禾力文创" },
      ];
      if (type === "name" && (value === 0 || value)) {
        let index = arr.findIndex((item) => item.id == value);
        return index != -1 ? arr[index].name : "-";
      } else if (type == "arr") {
        return arr.slice(1);
      } else {
        return "";
      }
    },

    orderStatusList(type, value, isString, number) {
      value = parseInt(value);
      let arr = [
        { id: 0, name: "待支付" },
        { id: 1, name: "待处理" },
        { id: 2, name: "已发货" },
        { id: 3, name: "已完成" },
        { id: 4, name: "失效" },
        { id: 5, name: "已取消" },
        { id: 6, name: "已完结" },
        { id: 7, name: "售后" },
      ];
      if (type === "name" && (value === 0 || value)) {
        // 调整条件顺序
        const item = arr.find((item) => item.id === value); // 直接使用 find
        return item ? item.name : "-";
      } else if (type === "arr") {
        if (number) {
          arr = arr.slice(0, number);
        }

        if (isString) {
          arr = arr.map((item) => ({
            ...item,
            id: item.id.toString(),
          }));
          return [...arr];
        }
        return [...arr]; // 返回完整数组副本
      } else {
        return "";
      }
    },
  },
};
